import {Link} from 'react-router-dom';

function AccessDenied() {
    return (
        <main className="flex items-center justify-center h-screen">
            <div className="px-8 max-w-lg">
                <h2 className='header-2'>403 - ACCESS DENIED</h2>
                <p className='py-4'>You do not have the right permissions to view this page.</p>
                <Link className="btn btn-aqua" to="/">HOME PAGE</Link>
            </div>
        </main>
    )
}

export default AccessDenied;
